<template>
  <div class="container">
    <img class="top-title" src="https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/store/6.png"/>
    <div class="back-btn" @click="toPage(4)">
      <img src="https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/my/1.png"/>
      <span>返回奖品页</span>
    </div>
    <div class="award-list">
      <div class="item" v-for="item in storeList" :key="item.id">
        <div class="info-wrap">
          <p class="name">{{ item.name }}</p>
          <p class="area">{{ item.area }}</p>
          <p class="address">{{ item.address }}</p>
        </div>
        <div class="btns">
          <img @click="openMap(item)" src="https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/store/7.png"/>
          <img @click="toCall(item.mobile)" src="https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/store/8.png"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Picker,Popup } from 'vant';
export default {
  props:['pageStep'],
  components:{
    Picker,
    Popup
  },
  data(){
    return {
      storeList:[
        {
          id:1,
          name:'音乐窝玩创中心（海珠旗舰店）',
          area:'广东省广州市海珠区',
          address: '翠华路9号',
          mobile:'18926179540',
          lnl:[113.26947381826722,23.082917842584138]
        },
        {
          id:2,
          name:'音乐窝玩创中心（海口旗舰店）',
          area:'海南省海口市龙华区',
          address: '金贸街道玉沙路京华城南门3楼音乐窝',
          mobile:'19840728843',
          lnl:[110.31994279421838,20.02673718929958]
        },
      ]
    }
  },
  methods:{
    toPage(i){
      this.$emit('update:pageStep',i);
    },
    toCall(num){
      window.location.href = 'tel://'+num;
    },
    openMap(item){
      this.mapPickerVisible = false;
      location.href = `https://uri.amap.com/marker?position=${item.lnl[0]},${item.lnl[1]}`;
    }
  }
}
</script>
<style lang="scss" scoped>
.container{
  height: 100vh;
  overflow: hidden auto;
  background-image: url(https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/draw/11.png);
  background-size: 100% 100%;
  background-position: center top;
}
.top-title{
  position: relative;
  width: 304px;
  height: auto;
  margin-top: 12px;
}
.back-btn{
  position: fixed;
  top:14px;
  right:10px;
  display: flex;
  align-items: center;
  z-index: 100;
  img{
    width: 40px;
    height: 40px;
  }
  span{
    font-size: 16px;
    line-height: 40px;
    color: rgba(255, 255, 255, 1);
    margin-left: 8px;
  }
}
.award-list{
  margin:-50px auto 0 auto;
  width: 294px;
  border-radius: 30px;
  background: rgba(31, 0, 78, 0.55);
  border: 2px solid rgba(255, 255, 255, 1);
  padding:56px 23px 1px 23px;
  .item{
    display: flex;
    text-align: left;
    align-items: center;
    border-radius: 16px;
    background: rgba(255, 255, 255, 0.1);
    padding:15px 12px;
    margin-bottom: 32px;
    position: relative;
    &::after{
      content:'';
      border-bottom: 1px dashed rgba(255, 255, 255, 1);
      position: absolute;
      left:0;
      right:0;
      bottom:-16px;
    }
    &:last-child{
      &::after{
        display: none;
      }
    }
    .info-wrap{
      flex: 1;
      color: #fff;
      .name{
        font-size: 16px;
        line-height: 22px;
        margin-bottom: 7px;
      }
      .area{
        font-size: 13px;
        opacity: 0.5;
        line-height: 20px;
      }
      .address{
        font-size: 13px;
        opacity: 0.5;
        line-height: 20px;
      }
    }
    .btns{
      img{
        display: block;
        height: 38px;
        width:38px;
        &:first-child{
          margin-bottom: 6px;
        }
      }
    }
  }
}
</style>